/* Store testimonials only. No product-rating data or third-party review widget. */
if (!customElements.get('b100-review-link')) {
  customElements.define('b100-review-link', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        target.focus({ preventScroll: true });
        target.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          block: 'start'
        });
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

if (!customElements.get('b100-review-list')) {
  customElements.define('b100-review-list', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      this.more = this.querySelector('[data-review-more]');
      this.less = this.querySelector('[data-review-less]');
      this.progress = this.querySelector('[data-review-progress]');
      this.pageSize = matchMedia('(max-width: 600px)').matches ? 3 : 6;
      this.visibleCount = this.pageSize;
      if (!this.more || !this.less || !this.progress || !this.cards.length) return;
      this.querySelector('[data-review-controls]').hidden = false;
      const options = { signal: this.controller.signal };
      this.more.addEventListener('click', () => {
        const firstNew = this.cards[this.visibleCount];
        this.visibleCount += this.pageSize;
        this.update();
        // Keep keyboard and screen-reader users at the newly revealed reviews.
        if (firstNew) {
          firstNew.tabIndex = -1;
          firstNew.focus({ preventScroll: true });
        }
      }, options);
      this.less.addEventListener('click', () => {
        this.visibleCount = this.pageSize;
        this.update();
        const section = this.closest('.b100-reviews');
        section.focus({ preventScroll: true });
        section.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }, options);
      this.update();
    }
    update() {
      this.visibleCount = Math.min(this.visibleCount, this.cards.length);
      this.cards.forEach((card, index) => { card.hidden = index >= this.visibleCount; });
      this.progress.textContent = `${this.visibleCount} από ${this.cards.length} επιλεγμένες κριτικές`;
      this.more.hidden = this.visibleCount >= this.cards.length;
      this.less.hidden = this.visibleCount <= this.pageSize;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
